import React, { useEffect, useState,useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import { Filter } from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import SiteStageCard from 'components/sales/cardSection/siteStageCard/siteStageCard';
import { Link, NavLink } from 'react-router-dom';
import "./siteStage.css";
// import "./siteStage.css";
import { Button } from "react-bootstrap";
import Images from 'assets/images/imageData';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from "../../../components/sales/Input/dropDownInput/dropDownInput";
import DistanceCalculator from "../../DistanceCalculator/Calculator";
import TableSection from "../../../components/sales/tableSection/tableSection";
import { toast } from 'react-toastify';
import useLatLng from 'hooks/uselatlng/uselatlng';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import {getIssuesList, saveSiteIssues} from "../../../services/redux/installation/siteStages/action";
import { ISSUE_DEPARTMENTS, getIssueSubcategories } from "../siteStages/issueCategoryOptions";
import {
  checkoutErrorMessage,
  isCheckoutApiSuccess,
  resolveDistanceRowId,
} from 'services/attendance/siteCheckout';

const ViewDailyTaskDetails = ({
  getSiteStage,
  siteStageData,
  siteDetails,
  history,
  latitude,
  longitude,
  match,
  isVendorAllocated,
  siteStageStatus,
  siteDismantle,
  siteUnhold,
  userProfile,
  getCheckLocation,locationCheck,
  getSiteData,
  calculateDistance,
  siteData,
  getDistanceDataDailyTaskAtt,
  dailyDistance,
  getDistanceData,
  distanceDetails,
  engDistanceData,
  saveSiteIssues,
  issuesList,
  getIssuesList,
  rmCheckOutRequest,
  rmCheckOutResponse,
}) => {

  const inputs = {
    reason :""
  };

  const [siteId, setSiteId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isStatusModal, setIsStatusModal] = useState(null);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [displayButton,setdisplayButton] = useState('none');
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [remarkData, setRemarkData] = useState('');
  const [status, setStatus] = useState('');
  const [responseData, setResponseData] = useState(null);
  const [remarkReasonValue, setRemarkReasonValue] = useState(inputs)
  const [isShowAttPopUp, showAttPopup] = useState(false)
  const [listData, setDailyTaskData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [role, setRole] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const islatlng = useLatLng();
  const [showIssuesForm, setShowIssuesForm] = useState(false);
  const [siteStages, setSiteStages] = useState([]);
  const [issueStage, setIssueStage] = useState('');
  const [issueDept, setIssueDept] = useState('');
  const [issueCategory, setIssueCategory] = useState('');
  const [issueRemarks, setIssueRemarks] = useState('');
  const [siteIssuesList, setSiteIssuesList] = useState([]);
  const [issuePageCount, setIssuePageCount] = useState(0);
  const [subcategoryResetKey, setSubcategoryResetKey] = useState(0);

  const handleModalHide = () => setIsModal(false);
  const handleModalHide2 = () => {
    setShowIssuesForm(false);
    setIssueStage('');
    setIssueDept('');
    setIssueCategory('');
    setIssueRemarks('');
    setSubcategoryResetKey((k) => k + 1);
  };

  const headers = ['Site Eng Name','Latitude', 'Longitude', 'Site Close Via', 'Remarks' ,'Created On'];

  const issues_headers = ['Stage', 'Department', localization.subcategory, 'Remarks', 'Created By' ,'Created On'];

  useEffect(() => {
    (async () => {
      setIsLoading(true)
      getDistanceDataDailyTaskAtt(match.params.id);
      setIsLoading(false)
    })()
  }, [])

  useEffect(() => {
    (async () => {
      setIsLoading(true)
      getIssuesList(match.params.id);
      setIsLoading(false)
    })()
  }, [])

  useEffect(() => {
    let roles = JSON.parse(localStorage.getItem('roles'))
    setRole(roles[0]?.id)
  }, [])

  useEffect(() => {
    if (siteStageData && siteStageData.length > 0) {
      let stage = [];
      siteStageData.map((obj, index) => {
        stage = [
          ...stage,
          {
            'id': obj.stage_id,
            'name': obj.name
          }
        ];
      });
      setSiteStages(stage);
    }
  }, [siteStageData])

  useEffect(() => {
    const tableData = ['name', 'lat', 'long', 'site_state_close_via','comments' ,'created_at'];
    if (dailyDistance && Object.keys(dailyDistance).length > 0) {

      const data = dailyDistance?.data.map((element) =>

          Object.assign(
              {},
              ...tableData.map((key) => ({[key]: element[key]})),
          )
      );
      data && setDailyTaskData(data);
      setPageCount(Math.ceil(dailyDistance.total / dailyDistance.per_page));
    }
  }, [dailyDistance]);

  useEffect(() => {
    const tableData = ['stage_name', 'department', 'issue_category', 'remarks','created_by' ,'created_at'];
    if (issuesList && Object.keys(issuesList).length > 0) {

      console.log(issuesList)
      const data = issuesList?.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({[key]: element[key]})),
        )
      );
      data && setSiteIssuesList(data);
      setIssuePageCount(Math.ceil(issuesList.total / issuesList.per_page));
    }
  }, [issuesList]);

   useEffect(() => {
      if(siteId) {
      (async () => {
          await getSiteData(siteId)
      })();
      }
  }, [siteId]);

  useEffect( () => {
    (async () => {
        console.log(siteId);
        setIsLoading(true)
        if(siteId !== undefined && siteId !== null && siteId != ""){
          await getDistanceData(siteId, 'daily-task')
        }
        setIsLoading(false)
    })()
  }, [siteId])

  // useEffect( () => {
  //   setIsOpen(true);
  //   if(distanceDetails !== {} && Object.keys(distanceDetails).length > 0 && distanceDetails.checkout_long == null){
  //     if(!distanceDetails['total_hours']){
  //       setIsOpen(false);
  //       console.log('ENTER');
  //     }
  //   }
  // }, [distanceDetails])

  useEffect(() => {
    setSiteId(match.params.id);
  }, []);
  useEffect(() => {
    if (getSiteStage !== null && siteId)
      (async () => {
        setIsLoading(true);
        await getSiteStage(siteId);
        if(siteDetails && siteDetails.status !=2 && siteDetails.status !=5){
          setdisplayButton('block');
        }else{
          setdisplayButton('none');
        }
        setIsLoading(false);
      })();
  }, [getSiteStage, siteId]);
   // useEffect( () => {
  //   setIsOpen(true);
  //   if(distanceDetails !== {} && Object.keys(distanceDetails).length > 0 && distanceDetails.checkout_long == null){
  //     if(!distanceDetails['total_hours']){
  //       setIsOpen(false);
  //       console.log('ENTER');
  //     }
  //   }
  // }, [distanceDetails])
  useEffect( () => {
    if(engDistanceData !== null && Object.keys(engDistanceData).length > 0){
      //console.log('eee ' + engDistanceData?.alreadyCheckIn);
      if(engDistanceData?.alreadyCheckIn == true) {
        toast.warning(engDistanceData?.message);
        history.push(`${baseUrl}/site-listing`);
        setTimeout(() => { 
          window.location.reload();
        },5000);
      } else {
        toast.success('Distance is successfully fetched');
        window.location.reload();
        setIsOpen(false);
        Object.keys(engDistanceData).forEach(key => {
          delete engDistanceData[key];
        })
      }
    }else if(engDistanceData === null){
      toast.success('Distance is not fetched');
      setIsOpen(true);
    }
  }, [engDistanceData])

  const onHoldFirst = async (e) => {
    // alert(e)
    setIsLoading(true);
    if(e){
      setStatus(5);
      setIsModal(true);
    }
    setIsLoading(false);
    
  };
  const onAbortFirst = async (e) => {
    // alert(e)
    setIsLoading(true);
    if(e){
      setStatus(6);
      setIsModal(true);
    }
    setIsLoading(false);
    
  };
  const onDismantleFirst = async (e) => {
    // alert(e)
    setIsLoading(true);
    if(e){
      setStatus(17);
      setIsModal(true);
    }
    setIsLoading(false);
    
  };

  const openIssuesForm = async (e) => {
    setIsLoading(true);
    if(e){
      setShowIssuesForm(true);
    }
    setIsLoading(false);

  };

  const submitIssue = async () => {
    setIsLoading(true);
    if(issueStage != '' && issueDept != '' && issueCategory != '' && issueRemarks != '') {
      let data = {
        site_id: siteId,
        stage_id: issueStage,
        dept: issueDept,
        issue_category: issueCategory,
        remarks: issueRemarks
      }
      const res = await saveSiteIssues(data);
      if(res.data.message){
        await getIssuesList(match.params.id);
        setIsLoading(false);
        handleModalHide2();
        toast.success('Issue Saved successfully!');
      }else{
        setIsLoading(false);
        toast.error('Some error occurred!');
      }

    }else{
      toast.error('Please fill all fields.');
      setIsLoading(false);
    }


  };

  const unhold = async (e) => {
    setIsLoading(true);
    if(e){
     
      const res = await siteUnhold(match.params.id);
      var msg = '';
      if(res.data.message){
        msg = res.data.message;
      }else{
        msg = 'Success!';
      }
      setIsStatusModal(msg);
      setIsStatusSuccess(true);
      await getSiteStage(siteId);
      setIsLoading(false);
      
    }else{
      setIsLoading(false);
    }
    
    
  };

  const onDismantle = async (e) => {
    setIsLoading(true);
    if(e){
    //  console.log(match.params.id+' --  '+remarkData); return false;
      const res = await siteDismantle(match.params.id,4,remarkData,'Dismantle');
      var msg = '';
      if(res.data.message){
        msg = res.data.message;
        if(res.data.response.data){
          setResponseData(res.data.response.data);
        }
      }else{
        msg = 'Success!';
      }
      setIsStatusModal(msg);
      setIsStatusSuccess(true);
      await getSiteStage(siteId);
     
      
    }
    setIsLoading(false);
    
  };

  const onDismantleCont = async (e) => {
    setIsLoading(true);
    setResponseData(null)
    if(e){
    //  console.log(match.params.id+' --  '+remarkData); return false;
      const res = await siteDismantle(match.params.id,17,remarkData,'Dismantle');
      var msg = '';
      if(res.data.message){
        msg = res.data.message;
        if(res.data.response.data){
          setResponseData(res.data.response.data);
        }
      }else{
        msg = 'Success!';
      }
      setIsStatusModal(msg);
      setIsStatusSuccess(true);
      await getSiteStage(siteId);
     
      
    }
    setIsLoading(false);
    
  };
  

  const onHold = async (e) => {
    // alert(e)
    console.log(remarkReasonValue['reason']);
    setIsLoading(true);
    if(e){
      if(remarkData && remarkReasonValue['reason']){

      const res = await siteStageStatus(match.params.id, 5,remarkData, remarkReasonValue['reason']);
      var msg = '';
      if(res.data.message){
        msg = res.data.message;
        setIsLoading(false);
      }else{
        setIsLoading(false);
        msg = 'Site is on hold!';
      }
      setIsStatusModal(msg);
      setIsStatusSuccess(true);
      await getSiteStage(siteId);
      setIsLoading(false);
      }else{
        setIsLoading(false);
        msg = 'Please Fill Remark!';
      }
      
    }else{
      setIsLoading(false);
    }
    
    
  };
  const onAbort = async (e) => {
    setIsLoading(true);
    if(e){
      if(remarkData){

        const res = await siteStageStatus(match.params.id, 6,remarkData);
      var msg = '';
      if(res.data.message){
        msg = res.data.message;
      }else{
        msg = 'Site is on hold!';
      }
      setIsStatusModal(msg);
      setIsStatusSuccess(true);
      await getSiteStage(siteId);
      }else{
        msg = 'Please Fill Remark!';
      }
      
    }
    
    setIsLoading(false);
    
  };

  const toRad = (Value) => {
    return Value * Math.PI / 180
  }

  const calcCrow = (lat1, lon1, lat2, lon2) => {
    var R = 6371 // km
    var dLat = toRad(lat2 - lat1)
    var dLon = toRad(lon2 - lon1)
    var lat1 = toRad(lat1)
    var lat2 = toRad(lat2)

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    var d = R * c
    return d
  }

  const handleCheckOut = async (passedId) => {
    const id = passedId || resolveDistanceRowId(distanceDetails);
    if (!id) {
      toast.error('Check-in record not found.');
      return false;
    }
    const checkout_lat = Number(islatlng?.lat);
    const checkout_long = Number(islatlng?.lng);
    if(isNaN(checkout_lat) || isNaN(checkout_long)) {
      alert(localization.locationPermission);
      return false;
    }
    var checkout_distance = calcCrow(checkout_lat, checkout_long, siteData['lead']['latitude'], siteData['lead']['longitude']);
    if(isNaN(checkout_distance) || checkout_distance == null || checkout_distance == undefined) {
      toast.error('Distance Not Fetched.');
      return false;
    }
    const payload = {
      'id':id,
      'checkout_lat':checkout_lat,
      'checkout_long':checkout_long,
      'checkout_distance_in_km': checkout_distance,
      'checkout_remark':'',
    }

    setIsLoading(true);
    try {
      const res = await rmCheckOutRequest(payload);
      if (isCheckoutApiSuccess(res?.data) || res?.success) {
        toast.success('Checkout Successfully.');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        return true;
      }
      toast.error(checkoutErrorMessage(res?.data));
    } catch (err) {
      toast.error(checkoutErrorMessage(err?.response?.data));
    } finally {
      setIsLoading(false);
    }
    return false;
  }

  console.log(distanceDetails);
  const headerBtns = () => {
    return (
      <Fragment>
        {distanceDetails && distanceDetails.lat != null && distanceDetails.checkout_lat == null ? (
          <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <Button
            className="btn btn-transparent btn-danger"
            onClick={() => handleCheckOut(distanceDetails?.id)}
            >
            {localization.checkOut}
            </Button>
          </div>
          </div>
      ) : ''}
        <Button
            className="btn btn-primary"
            onClick={() => {
              handlePopupShowOrHide()
            }}
        >
          {localization.addDailyTask}
        </Button>
        <Button
          onClick={() => openIssuesForm(true)}
          className="btn btn-primary"
        >
          {" "}
          Issues Encountered
        </Button>
      </Fragment>
    );
  };

  const handlePopupShowOrHide = () => {
    showAttPopup(true)
  }

  const onPageChange = async (val) => {
    setIsLoading(true);
    getDistanceDataDailyTaskAtt(match.params.id, val.selected + 1);
    setIsLoading(false);
  };

  const onIssuePageChange = async (val) => {
    setIsLoading(true);
    getIssuesList(match.params.id, val.selected + 1);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.dailyTaskAndIssueEncounter}
      isGoback
      linkFlag={true}
      linkUrl={`/dashboard/site-listing-engg`}
      isLoading={isLoading}
      Buttons={headerBtns}
    >
      <div className="row" >
      {siteDetails && siteDetails[0].site_id >0 &&   
        <>
         <div className="col-md-6 col-xs-12">
          <h4>{siteDetails[0].client_name} ({siteDetails[0].site_no})</h4>
         </div>
         <div className="col-md-3"></div>
        </>
      }
      {siteDetails && siteDetails[0].status === 2 && 
            
          <div className="col-md-3 col-xs-12">
              <h4 style={{'color' : 'green'}}> Live</h4>
          </div>
    
      }
      {siteDetails && siteDetails[0].status === 6 && 
          <div className="col-md-3 col-xs-12">
              <span style={{'color' : 'red'}}> Aborted</span>
          </div>
      }
       {siteDetails && siteDetails[0].status === 14 && 
        
          <div className="col-md-3 col-xs-12">
              <span style={{'color' : 'red'}}> Abort Approval Pending</span>
          </div>
    
      }
      {siteDetails && siteDetails[0].status === 15 && 
            
          <div className="col-md-3 col-xs-12">
              <span style={{'color' : 'orange'}}> Hold Approval Pending</span>
          </div>
    
      }
      {siteDetails && siteDetails[0].status === 5 && 
                 
          <div className="col-md-3 col-xs-12">
              <span style={{'color' : 'orange'}}> Hold</span>
          </div>
    
      }
       {siteDetails && siteDetails[0].status === 4 && 
                 
                 <div className="col-md-3 col-xs-12">
                     <span style={{'color' : 'red'}}> Dismantled</span>
                 </div>
           
        }
        {siteDetails && siteDetails[0].status === 17 && 
            
            <div className="col-md-3 col-xs-12">
                <span style={{'color' : 'orange'}}> Dismantle Pending</span>
            </div>
      
        }
      </div>
      {role === 9 && isOpen ?
          <div className="popup-box">
            <div className="box">
              <Link
                  to={`${baseUrl}/site-listing`}
                  className="btn btn-primary mb-4"
                  style={{'cursor': 'pointer','float':'right','border':'0px','box-shadow':'none !important','position':'relative','top':'-17px'}}
              >
                x
              </Link>
              {siteId && siteId !== undefined && siteId !== null && siteId != '' ?
                    <DistanceCalculator
                        siteData={siteData}
                        getSiteData={getSiteData}
                        calculateDistance={calculateDistance}
                        siteId={siteId !== '' ? siteId : "testing"}
                        moduleType={"site_stage"}
                    /> :
                  ""}
            </div>
          </div> :
      <>    
      <div clasName="panel-catalogue">
            <div className="container-fluid daily-task-container">
              <div className="card">
                <div className="card-header daily-task-header">
                  <div className="daily-header-title">{localization.dailyTask}</div>
                </div>
                <div className="card-body">
                  <TableSection
                      data={listData}
                      isId={false}
                      isMngId={false}
                      headers={headers}
                      pageCount={pageCount}
                      onPageChange={onPageChange}
                      onChange={() => {
                      }}
                      detailList={listData && listData}
                      srNo={dailyDistance?.from}
                  />
                </div>
              </div>
            </div>

        <div className="container-fluid daily-task-container">
          <div className="card">
            <div className="card-header daily-task-header">
              <div className="daily-header-title">{localization.issueEncountered}</div>
            </div>
            <div className="card-body">
              <TableSection
                data={siteIssuesList}
                isId={false}
                isMngId={false}
                headers={issues_headers}
                pageCount={issuePageCount}
                onPageChange={onIssuePageChange}
                onChange={() => {
                }}
                detailList={siteIssuesList && siteIssuesList}
              />
            </div>
          </div>
        </div>

      </div>
      </>
      }
      {isShowAttPopUp ?
          <div className="popup-box">
            <div className="box">
              {siteData?.lead_id !== undefined &&
                  <Link
                      className="btn btn-primary mb-4"
                      style={{
                        'cursor': 'pointer',
                        'border': '0px',
                        'boxShadow': 'none !important',
                        'position': 'relative',
                        'top': '-17px',
                        'float':'right'
                      }}
                      to={"#"}
                      onClick={() => {window.location.reload()}}
                  >
                    x
                  </Link>
              }

              <DistanceCalculator
                  siteData={siteData}
                  getSiteData={getSiteData}
                  calculateDistance={calculateDistance}
                  siteId={match.params.id}
                  moduleType={'daily-task'}
                  isMapShow={false}
                  to={"#"}
              />
            </div>
          </div>
          : ""
      }

      {/*Issues Encountered Form Modal Start*/}
      <ModalPop
        title={localization.issueEncountered}
        show={showIssuesForm}
        handleModalHide={handleModalHide2}
        keyboard
      >
        <div className="text-center">
          {/*{siteStages && siteStages.length > 0 ?*/}
          <DropDownInput
            label={localization.stage}
            required={true}
            data={siteStages}
            getIdValue={(val) =>{
              setIssueStage(val.id)
            }}
            isStarRequired={true}
          />
          <DropDownInput
            label={localization.deptDepend}
            required={true}
            data={ISSUE_DEPARTMENTS}
            getIdValue={(val) =>{
              setIssueDept(val.id)
              setIssueCategory('')
              setSubcategoryResetKey((k) => k + 1)
            }}
            isStarRequired={true}
          />
          <DropDownInput
            key={`issue-subcat-${subcategoryResetKey}`}
            label={localization.subcategory}
            required={true}
            data={getIssueSubcategories(issueDept)}
            getIdValue={(val) =>{
              setIssueCategory(val.id)
            }}
            isStarRequired={true}
            disabled={!issueDept}
          />

          <ConstantInput
            label='Remark'
            type="text"
            handleChange={(val) =>
              setIssueRemarks(val)
            }
            isStarRequired={true}
            required
          />
          <Button
            className="btn btn-primary mb-4"
            onClick={() => submitIssue()}
          >
            {localization.submit}
          </Button>
        </div>
      </ModalPop>
      {/*Issues Encountered Form Modal End*/}
    </Layout>
  );
};

export default ViewDailyTaskDetails;
